import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wz-form-group-part',
  templateUrl: './form-group-part.component.html',
  styleUrls: ['./form-group-part.component.scss'],
  standalone: false,
})
export class FormGroupPartComponent implements OnInit {
  ngOnInit(): void {}
}
